// Copyright 2016 Sorama B.V.

import { IHardwareDevice } from "services/Hardware/Datatypes/IHardwareDevice";
export abstract class IHardwareService<THardware extends IHardwareDevice> {
    /* Force the hardware service to scan for added/removed devices. The results
    of the scan are returned in the promise. The hardware property is updated as
    a side effect. */
    public abstract refresh(): Promise<void>;

    /* Get the hardware identified by the given id */
    public abstract getHardwareById(id: string): Promise<THardware>;

    /* Get a cached list of all discovered hardware devices. If possible, the hardware
    service should automatically scan for added/removed devices in the background
    and update this list when changes are found. */
    public readonly hardware: THardware[];

    /* True while the device list is being refreshed (explicitly or in the background). */
    public readonly isRefreshing: boolean;
}
